import { BrokerageGetRequestQuery, BrokerageSearchResponse } from '@lio/api-types';
import { brokerageKeys } from '@services/brokerage/keys';
import { getBrokeragesQuery } from '@services/brokerage/brokerage.helpers';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchPaginatedBrokerages = (enabled: boolean, params: BrokerageGetRequestQuery) => {
  const client = useClient();
  const query = getBrokeragesQuery(params);
  const result = useInfiniteQuery<BrokerageSearchResponse, Error>({
    queryKey: brokerageKeys.searchWithParams(params),
    queryFn: ({ pageParam }) =>
      client.get(`brokerage?${query}&pageOffset=${pageParam}`).json<BrokerageSearchResponse>(),
    initialPageParam: 0,
    enabled,
    staleTime: 2000,
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.pagination) return undefined;
      if (!lastPage.pagination.pageLimit) return undefined;
      if (!lastPage.pagination.total) return undefined;
      const { total, pageLimit } = lastPage.pagination;
      const fetchedPageCount = allPages.length;
      const nextPageOffsetValue = fetchedPageCount * pageLimit;
      if (nextPageOffsetValue > total) return undefined;
      return nextPageOffsetValue;
    },
  });

  return { ...result, searchBrokerage: result.data };
};
